import { useQuery } from '@tanstack/react-query';
import { diContainer } from 'src/inversify.config';
import GetProductsByBrandUseCase from '../../domain/useCases/GetProductsByBrandUseCase';
import useStoreSlug from 'src/common/hooks/useStoreSlug';
import { getStorageSession } from 'src/utils/localStorage/session';

interface UseBrandProductsParams {
  brandSlug: string;
}

const getProductsByBrandUseCase = diContainer.get(GetProductsByBrandUseCase);

export const useBrandProducts = ({ brandSlug }: UseBrandProductsParams) => {
  const { storeSlug } = useStoreSlug();
  const session = getStorageSession();

  const query = useQuery({
    queryKey: ['products', 'brand', brandSlug],
    queryFn: () =>
      getProductsByBrandUseCase.execute({
        storeSlug,
        brandSlug,
        token: session?.accessToken,
      }),
    enabled: !!brandSlug && !!storeSlug,
  });

  return {
    ...query,
    brandProducts: query.data,
  };
};
